import normalizeText from './normalize-Text';

const extractObjectFromTable = (html: any) => {
  let contentDiv = html;

  if (typeof (html) === 'string') {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    contentDiv = doc.querySelector('table');
  }

  if (contentDiv instanceof Element) {
    const rows = contentDiv.querySelectorAll('tr');
    const extractedData: any = {};

    rows.forEach((row: any) => {
      const cells = row.querySelectorAll('td');

      if (cells.length === 2) {
        const label = normalizeText(cells[0].textContent)?.replace(' ', '_');
        const value = cells[1].textContent?.trim();

        if (label && value) {
          extractedData[label] = value;
        }
      }
    });

    return extractedData;
  }

  return null;
};

export default extractObjectFromTable;
